import { buildViewLayer } from "./buildLayer.js";
export let PageLayerType = /*#__PURE__*/function (PageLayerType) {
  PageLayerType["HOME"] = "home";
  PageLayerType["OVERVIEW"] = "overview";
  PageLayerType["FORM"] = "form";
  PageLayerType["ARTICLE"] = "article";
  PageLayerType["CALCULATOR"] = "calculator";
  PageLayerType["LANDING_PAGE"] = "landing page";
  return PageLayerType;
}({});
export let SiteResponsiveType = /*#__PURE__*/function (SiteResponsiveType) {
  SiteResponsiveType["MOBILE"] = "mobile";
  SiteResponsiveType["DESKTOP"] = "desktop";
  return SiteResponsiveType;
}({});
export const buildPageLayer = buildViewLayer();